const spend = ({primary, secondary}) => (
    <svg  xmlns="http://www.w3.org/2000/svg" viewBox="0 0 186.1 159.4" width="190" 
  >
        <g fill="none" fillRule="evenodd">
            <g>
                <path stroke={primary} strokeWidth="2" strokeLinecap="round" strokeMiterlimit="10" d="M4.6,125.8v5.3c0,7.8,6.9,20.8,15.4,20.8h83.9c8.5,0,15.4-13,15.4-20.8v-5.3 M120.1,110.1
			c0-8.1-3.5-20.4-9.5-24c-8.5-5.1-23.7-11.2-47.9-11.2l-0.7,0l-0.7,0C37,74.9,21.8,81,13.3,86.2c-5.9,3.6-9.5,15.9-9.5,24
			 M122.9,118.6H1"/>
                <path stroke={secondary} strokeWidth="2" strokeLinecap="round" strokeMiterlimit="10" d="M80.1,70.8l-4.2-28.4c-0.1-0.3-0.1-0.6-0.1-1c0.1-2.3,2-4.1,4.3-4.1h87.5c2.3,0,4.2,1.8,4.3,4.2
			c0,0.3,0,0.6-0.1,1c-0.5,3.2-11.4,79.3-14.4,100.4c-0.7,5-4.8,8.7-9.8,8.8c-5.1,0.1-19.7,0.1-28.6,0.1h0 M178.2,1l-21.9,6.9
			c-1.5,0.5-2.6,1.8-2.9,3.3l-4.1,21.1"/>
            </g>
        </g>
    </svg>
)

export default spend;